export const parameterize = (parameters = {}) =>
  Object.entries(parameters).map(([key, value]) => `${key}=${encodeURIComponent(value)}`).join('&');
